<template>
  <div style="overflow: hidden; position: relative">
    <vs-row class="modal-wrapper">
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        {{ "ترتیب دسته بندی ها:" }}
        <vs-select v-model="category" width="100%">
          <vs-select-item
            v-for="(category, index) in categories"
            :value="category"
            :text="`${index + 1} - ${category.title}`"
            :key="index"
            icon="arrow_downward"
          />
        </vs-select>
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        نام دسته بندی:
        <vs-input v-model="categoryClone.title" class="w-100 mt-1" />
      </vs-col>
      <template v-if="!createMode">
        <vs-col vs-justify="center" vs-align="center" vs-w="6">
          ترتیب نمایش:
          <vs-input v-model="categoryClone.level" class="w-100 mt-1" />
        </vs-col>
        <vs-col vs-justify="center" vs-align="center" vs-w="6"></vs-col>
      </template>
      <vs-col vs-w="12">
        <attachments
          ref="thumbnailAttachments"
          :data="categoryClone.thumbnail ? [categoryClone.thumbnail] : []"
          :aspectRatio="2"
          :multiple="false"
          accept="image/*"
          :urlForDelete="`categories/${categoryClone.id}/`"
          title="انتخاب تصویر:"
        />
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="5">
        <vs-checkbox
          v-model="categoryClone.visible"
          :value="categoryClone.visible"
          >نمایش دسته بندی</vs-checkbox
        >
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="7">
        <vs-checkbox
          v-model="categoryClone.available"
          :value="categoryClone.available"
          >موجودیت محصولات این دسته بندی</vs-checkbox
        >
      </vs-col>
    </vs-row>
    <div class="footer">
      <loading-button
        @confirm="sendRequest"
        @cancelUpload="cancelUpload"
        :title="(createMode ? 'ایجاد' : 'ویرایش') + ' دسته بندی'"
        :loading="loading"
        :progress="progress"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Attachments from "../../views/tickets/form/Attachments";
import LoadingButton from "../loading-button/LoadingButton.vue";
import productApiService from "./../../services/api/ProductApiService";

export default {
  name: "Input",
  components: { Attachments, LoadingButton },
  data() {
    return {
      categoryClone: { ...this.value },
      category: this.value,
      Blob: window.Blob,
      progress: 0,
      loading: false,
      abortController: null,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  mounted() {
    if (this.createMode)
      this.categoryClone = {
        ...this.value,
        available: true,
      };
  },
  methods: {
    handleUpload(blob) {
      this.categoryClone = {
        ...this.categoryClone,
        thumbnail: {
          url: blob,
        },
      };
    },
    checkLevel() {
      return this.categories
        ? this.categories[this.categories.length - 1]
          ? +this.categories[this.categories.length - 1].level + 1
          : 1
        : 1;
    },
    sendRequest() {
      this.abortController = new AbortController();

      this.categoryClone = {
        ...this.categoryClone,
        thumbnail: this.$refs.thumbnailAttachments.getData(),
      };

      const category = { ...this.categoryClone };

      if (this.createMode) category.level = this.checkLevel();

      if (!category.title) {
        this.$vs.notify({
          text: "لطفا تمامی فیلد ها را وارد کنید",
          color: "danger",
          position: "bottom-center",
        });
        return;
      }

      this.loading = true;
      productApiService
        .createOrEditCategory(
          this.currentProvider.id,
          category.id,
          category,
          null,
          this.updateProgress,
          this.abortController
        )
        .then((result) => {
          this.$emit("close");
          this.$emit(
            this.createMode ? "categoryAdded" : "categoryUpdated",
            result.resource
          );
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
        })
        .catch((err) => {
          if (err.status == 0) return;

          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.progress = 0;
          this.loading = false;
        });
    },
    updateProgress(percent) {
      this.progress = +percent;
    },
    cancelUpload() {
      this.progress = 0;
      this.abortController.abort();
    },
  },
  watch: {
    category(selectedCategory) {
      if (!this.createMode) {
        this.categoryClone = { ...selectedCategory };
      }
    },
  },
  props: {
    value: {
      type: Object,
    },
    categories: {
      type: Array,
      required: true,
    },
    createMode: {
      tyoe: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.modal-wrapper {
  position: relative;
  padding-bottom: 120px;
  max-height: 700px;
  overflow-y: scroll;
}
.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background-color: #fff;
  padding: 1rem 0 0;
  border-radius: 10px;

  .progress-bar {
    border-radius: 10px;
  }
}
</style>
